(function () {
  'use strict';

  function syncVideos(swiper) {
    if (!swiper || !swiper.el) return;
    var slides = swiper.el.querySelectorAll('.swiper-slide');
    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video) return;
      if (slide.classList.contains('swiper-slide-active')) {
        var play = video.play();
        if (play && typeof play.catch === 'function') play.catch(function () {});
      } else {
        video.pause();
      }
    });
  }

  function unlockNav(btn) {
    if (!btn) return;
    btn.removeAttribute('disabled');
    btn.classList.remove('swiper-button-disabled', 'swiper-button-lock', 'dcf-nav--disabled');
  }

  function initCoverflow(root) {
    if (!root || root.dataset.dcfInit === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var el = root.querySelector('[data-dcf-swiper]');
    if (!el) return;

    root.dataset.dcfInit = 'true';

    var prev = root.querySelector('[data-dcf-prev]');
    var next = root.querySelector('[data-dcf-next]');
    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var carousel = root.querySelector('.dcf-carousel');

    var swiper = new Swiper(el, {
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop: false,
      rewind: true,
      watchOverflow: false,
      watchSlidesProgress: true,
      speed: 600,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 120,
        modifier: 1,
        scale: 0.7,
        slideShadows: false
      },
      on: {
        init: function (instance) {
          if (carousel) carousel.classList.add('is-ready');
          unlockNav(prev);
          unlockNav(next);
          syncVideos(instance);
        },
        slideChange: function (instance) {
          unlockNav(prev);
          unlockNav(next);
          syncVideos(instance);
        },
        slideChangeTransitionEnd: function (instance) {
          unlockNav(prev);
          unlockNav(next);
          syncVideos(instance);
        }
      }
    });

    function goBy(delta) {
      if (!slideCount) return;
      var current = typeof swiper.realIndex === 'number' ? swiper.realIndex : 0;
      var target = (current + delta + slideCount) % slideCount;
      swiper.slideTo(target, 600);
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        goBy(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        goBy(1);
      });
    }

    root._dcfSwiper = swiper;
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      window.setTimeout(boot, 80);
      return;
    }
    document.querySelectorAll('[data-design-coverflow]').forEach(initCoverflow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-design-coverflow]');
    if (section) {
      section.dataset.dcfInit = '';
      boot();
    }
  });
})();
